import { render } from "./SubmenuContextGroup.vue?vue&type=template&id=b4105fbc"
import script from "./SubmenuContextGroup.vue?vue&type=script&lang=js"
export * from "./SubmenuContextGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__